import styles from './O_CapsulePreviewHeader.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import cn from 'classnames';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { useTranslation } from '@/hooks/useTranslation';

interface O_CapsulePreviewHeaderProps {
  isExpanded: boolean;
  onToggleExpanded: () => void;
  onExit?: () => void;
  onActivate?: () => void;
  onPublish?: () => void;
  variant?: 'default' | 'light';
  showExpandButton?: boolean;
}

export default function O_CapsulePreviewHeader({
  isExpanded,
  onToggleExpanded,
  onExit,
  onActivate,
  onPublish,
  variant = 'default',
  showExpandButton = true,
}: O_CapsulePreviewHeaderProps) {
  const t = useTranslation();
  const textClass =
    variant === 'light'
      ? cn(styles.back_button_text, styles.light_text, 'text-p-6')
      : cn(styles.back_button_text, 'text-p-6');

  return (
    <header className={styles.wrapper}>
      <div className={styles.left_wrapper}>
        <button className={styles.back_button} onClick={onExit}>
          <Q_Icon.BackArrowIcon
            width={33}
            height={12}
            fill='none'
            stroke={
              variant === 'light'
                ? 'var(--color-surface-white)'
                : 'var(--color-text-dark-fill-600)'
            }
          />
          <span className={textClass}>{t('header.exitPreview')}</span>
        </button>
        {(onPublish || onActivate) && (
          <A_Button
            variant='primary'
            size='small'
            fontSize='text-p-4'
            showIcon={false}
            onClick={onPublish ?? onActivate}
          >
            {onPublish
              ? t('capsuleReactions.create')
              : t('header.activateCapsule')}
          </A_Button>
        )}
      </div>
      <div className={styles.right_wrapper}>
        {showExpandButton && (
          <A_CircleButton
            icon={
              isExpanded ? (
                <Q_Icon.ExpandIcon width={24} height={24} fill='none' />
              ) : (
                <Q_Icon.ReduceIcon width={24} height={24} fill='none' />
              )
            }
            variant='secondary'
            onClick={onToggleExpanded}
          />
        )}
      </div>
    </header>
  );
}
